import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

export const PriceText = styled.span`
  ${TypeStyle.css.bodyNano};
  font-weight: bold;
`
